import { render } from "./CompanyStorageView.vue?vue&type=template&id=16fc545a&ts=true"
import script from "./CompanyStorageView.vue?vue&type=script&lang=ts"
export * from "./CompanyStorageView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__